import Button from "@ergeon/core-components/exports/Button.ts";
import * as Dialog from '@radix-ui/react-dialog';
import NiceModal from '@ebay/nice-modal-react';

import { Permissions } from '@/app/types';
import { useModal } from '@/modals/hooks';

import IconCross from '@/assets/icons/cross.svg?react';
import IconWarning from '@/assets/icons/exclamation-triangle.svg?react';
import IconSettings from '@/assets/icons/settings-icon.svg?react';


const ResetPermissionsModal = NiceModal.create(({ permissions }: { permissions: Permissions }) => {
  const { onOpenChange, open } = useModal();

  const getPermissionsLabel = (permissions: Permissions): string => {
    const { audio, video } = permissions;
    return [audio && 'microphone', video && 'camera'].filter(Boolean).join(' and ');
  };

  return (
    <Dialog.Root onOpenChange={onOpenChange} open={open}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/50 data-[state=open]:animate-overlayShow" />
        <Dialog.Content className="data-[state=open]:animate-contentShow fixed left-1/2 top-1/2 max-h-[85vh] w-11/12 max-w-md -translate-x-1/2 -translate-y-1/2 rounded-lg bg-white p-6 shadow-2xl focus:outline-none dark:bg-gray-800 dark:text-gray-100">
          <Dialog.Title className="relative m-0 font-heading text-3xl font-bold leading-tight">
            <IconWarning fill="orange" className="mr-1 inline-block size-6" />
            Grant permissions to continue
          </Dialog.Title>
          <Dialog.Description className="mb-5 mt-3 text-sm leading-5 text-gray-700 dark:text-gray-300">
            <ol className='list-decimal list-inside'>
              <li className='mb-2'>
                Click the <IconSettings className='inline-block' /> in your browser's address bar
              </li>
              <li className='mb-2'>
                Clear {getPermissionsLabel(permissions)} permission
              </li>
              <li className='mb-2'>
                Refresh the page
              </li>
            </ol>
          </Dialog.Description>
          <div className="mt-6 flex justify-end">
            <Dialog.Close asChild>
              <Button flavor="primary" isFullWidth>
                Ok
              </Button>
            </Dialog.Close>
          </div>
          <Dialog.Close asChild>
            <button
              className="absolute right-3 top-3 inline-flex size-6 appearance-none items-center justify-center rounded-full text-gray-500 hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-1 dark:text-gray-400 dark:hover:bg-gray-700"
              aria-label="Close"
            >
              <IconCross />
            </button>
          </Dialog.Close>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
});

export default ResetPermissionsModal;
